import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from 'lodash';
import { LEGEND_COLORS } from '../../../../reports-constants';
import HeroCard from '../../../../../../components/HeroCard/HeroCard';

const moduleComponent = ({ unitActive, hasStudents, onTabChange, showModuleReportButton }) => {
  const heroTitle = 'Most Active Unit This Week: ';
  const modalContent = (
    <div>
      <p>
        This card identifies the unit in which students completed the most assignments that either were due in past 7 days or are due in the next 7 days.</p>
      <p><b>Assignments in this Unit</b> represents the total number of resources (readings, activities, assessments) assigned to your students in this Unit.</p>
      <p><b>Students completed % of assignments</b> represents the proportion of assignments in this Unit completed across all students in your class.</p>
      <p><b>There are # students scoring below 60%</b> represents the number of students in your class who are earning below 60% on assessments in this Unit that measure proficiency (i.e. quizzes and tests where students are granted only one attempt per question).</p>
      <p><b>Students answered % questions correctly on first try</b> represents the proportion of questions in this Unit that were correct on a student&apos;s first try. This includes any question in this Unit answered by any student in your class.</p>
    </div>
  );

  const nullStateContent =
    hasStudents ?
    (<p>
      There was no student activity on recent or upcoming assignments this week.<br />
      Go to the <button role="link" onClick={() => { onTabChange('assignments'); }}>Course Planner</button> to set up and manage assignments.
    </p>
    ) : (<p>
      No students have enrolled in this course.<br />
      Go to the <button role="link" onClick={() => { onTabChange('people'); }}>People</button> tab to invite students to enroll.
    </p>
    );

  const lowScoringStudentsIsSingular = (unitActive && unitActive.lowScoringStudents === 1);
  const assignmentsIsSingular = (unitActive && unitActive.assignments === 1);

  const heroData = isEmpty(unitActive) ? []
    :
  [
    {
      title: `There ${assignmentsIsSingular ? 'is' : 'are'}`,
      color: LEGEND_COLORS.BLACK,
      text: unitActive.assignments,
      bottomText: assignmentsIsSingular ? 'Assignment in this Unit' : 'Assignments in this Unit',
    },
    {
      title: 'Students Completed',
      color: LEGEND_COLORS.BLACK,
      text: `${Math.round(unitActive.completedAssignmentsPercentage * 100)}%`,
      bottomText: 'of Assignments',
    },
    {
      title: `There ${lowScoringStudentsIsSingular ? 'is' : 'are'}`,
      color: LEGEND_COLORS.BLACK,
      text: unitActive.lowScoringStudents > 0 ? unitActive.lowScoringStudents : '—',
      bottomText: `${lowScoringStudentsIsSingular ? 'Student' : 'Students'} Scoring Below 60%`,
    },
    {
      title: 'Students Answered',
      color: LEGEND_COLORS.BLACK,
      text: unitActive.correctOnFirstTry > 0 ? `${Math.round(unitActive.correctOnFirstTry * 100)}%` : '—',
      bottomText: 'of Questions Correctly On Their First Try',
    },
  ];
  const reportUrl = unitActive && unitActive.id ? `reports/type/unit/${unitActive.id}` : '';
  const buttonText = 'View Unit Report';
  const activeUnitTitle = unitActive && unitActive.name ? unitActive.name : 'None';
  const modalTitle = 'Most Active Unit This Week';

  return (<HeroCard
    heroData={heroData}
    heroTitle={heroTitle}
    activeModuleTitle={activeUnitTitle}
    modalTitle={modalTitle}
    modalContent={modalContent}
    showNullStateMessage={!hasStudents || heroData.length === 0}
    nullStateMessage={nullStateContent}
    showModuleReportButton={showModuleReportButton}
    reportUrl={reportUrl}
    buttonText={buttonText}
    onTabChange={onTabChange}
  />);
};

moduleComponent.propTypes = {
  unitActive: PropTypes.object,
  hasStudents: PropTypes.bool,
  onTabChange: PropTypes.func,
  showModuleReportButton: PropTypes.bool,
};
export default moduleComponent;
